import { createFeatureSelector, createSelector } from '@ngrx/store'
import { resolveLocalizedMessages } from '../../shared/i18n/i18n.utils'
import { Advisory } from '../advisories/advisories.types'
import { selectIsLoading } from '../ui/loading/loading.selectors'
import { TOW_SERVICE_AVAILABILITY } from './tow-service-availability.actions'
import { TowServiceAvailabilityState } from './tow-service-availability.reducer'
import { TowServiceAvailability } from './tow-service-availability.types'

const stateKey = 'towServiceAvailability'

export const selectTowServiceAvailabilityState =
  createFeatureSelector<TowServiceAvailabilityState>(stateKey)

export const selectTowServiceAvailability = createSelector(
  selectTowServiceAvailabilityState,
  (state): TowServiceAvailability | null => state?.towServiceAvailability ?? null
)

// The in-flight flag lives in the global loading state (loading.meta.ts),
// the same one tow-location-step reads; the slice does not duplicate it.
export const selectIsTowServiceAvailabilityLoading = selectIsLoading(
  TOW_SERVICE_AVAILABILITY.ACTION
)

export const selectIsTowServiceAvailabilityDeferred = createSelector(
  selectTowServiceAvailabilityState,
  (state): boolean => !!state?.deferred
)

// Whether the club allows towing to the selected destination. Defaults to true
// so a missing or failed response never blocks the user (fail-open).
export const selectIsTowDestinationEnabled = createSelector(
  selectTowServiceAvailability,
  (towServiceAvailability): boolean => towServiceAvailability?.enabled ?? true
)

// The club's advisory for a blocked destination, flattened into the Advisory[]
// shape the tow restriction dialog renders.
export const selectTowServiceAvailabilityAdvisories = createSelector(
  selectTowServiceAvailability,
  (towServiceAvailability): Array<Advisory> =>
    resolveLocalizedMessages(towServiceAvailability?.advisoryMessages || []).map(
      (msg) => ({ msg })
    )
)
